import { default as indexSNIqOhb9zfMeta } from "/home/debian/projects/my-website/pages/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/debian/projects/my-website/pages/index.vue").then(m => m.default || m)
  }
]